import { mdiInformation, mdiShieldHalfFull } from '@mdi/js';
import Icon from '@mdi/react';

function Modal({
  children,
  closeModal,
  width,
  variant,
  label,
  backgroundDark,
  noHeaderLine,
}) {
  return (
    <div className='modal is-active' style={{ zIndex: 999 }}>
      <div
        className='modal-background'
        style={
          backgroundDark
            ? { backgroundColor: 'black', opacity: 0.96 }
            : {}
        }
        onClick={closeModal}
      ></div>
      <div
        className='modal-content flex justify-center'
        style={{
          width: width,
        }}
      >
        <div style={{ width: '100%' }}>
          <div className='card' style={{ position: 'relative' }}>
            {closeModal && (
              <button
                onClick={closeModal}
                className='delete c-modal'
                aria-label='close'
                style={{ position: 'absolute', right: 16, top: 22 }}
              ></button>
            )}
            <div
              className='card-content'
              style={{ padding: '0px 0px 20px 0px' }}
            >
              {variant && (
                <>
                  {(!label || (label && label !== 'noLabel')) && (
                    <p
                      className={`has-text-${variant} flex justify-start align-center is-size-5 px-4 py-4`}
                    >
                      <span className='icon is-medium'>
                        <Icon
                          path={label ? mdiInformation : mdiShieldHalfFull}
                          size={1}
                        />
                      </span>
                      {label ? label : 'Konfirmasi'}
                    </p>
                  )}
                </>
              )}
              {!noHeaderLine && (
                <div className='c-modal-header-line'></div>
              )}
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
